import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Body from './Body.js';
import Menu from './Menu.js';
import Submenu from './Submenu.js';
import SidebarContext from './SidebarContext.js';
import Item from './Item.js';

/*
se delego Sidebar a determina il componente attivo,
ricavo i link dai children e scelgo quello con lunghezza maggiore.
PER ORA NON NECESSARIO

function isLinkActive(link, pathname) {
  if (link === '/') return false;
  return link === pathname || matchPath(pathname, { path: link, exact: false, strict: false });
}

function getLinksInTree(children, links = []) {
  if (children) {
    return React.Children.toArray(children).reduce((acc, child) => {
      const result = [...acc];
      if (child.props && child.props.link) result.push(child.props.link);
      return getLinksInTree(child.props && child.props.children, result);
    }, links);
  }
  return links;
}

...

  const isActive = useCallback((link, pathname) => {
    if (!isLinkActive(link, pathname)) {
      return false;
    }
    // di tutti i link con match, il corrente è quello più lungo!
    const r = links.reduce((max, l) => {
      if (l.length > max && isLinkActive(l, pathname)) return l.length;
      return max;
    }, -1);
    return r === link.length;
  }, [links]);
...
*/
function SidebarImpl({ open, children, className, onOpenChanged, }) {
    const [openInternal, setOpen] = useState(open);
    const toggle = useCallback(() => {
        const newOpenInternal = !openInternal;
        setOpen(newOpenInternal);
        onOpenChanged === null || onOpenChanged === void 0 ? void 0 : onOpenChanged(newOpenInternal);
    }, [onOpenChanged, openInternal]);
    const classes = useMemo(() => cns('sidebar', {
        'sidebar--open': open,
    }, className), [open, className]);
    const sidebarContext = useMemo(() => ({
        openCallback: toggle,
        open: openInternal,
    }), [openInternal, toggle]);
    return (jsx(SidebarContext.Provider, { value: sidebarContext, children: jsx("div", { className: classes, children: children }) }));
}
SidebarImpl.defaultProps = {
    children: null,
    className: '',
    open: false,
    onOpenChanged: undefined,
};
/**
Il componente Sidebar permette di disegnare una sidebar con degli elementi di menu opzionalmente annidati.
*/
const Sidebar = function Sidebar({ open, children, className, onOpenChanged, }) {
    return (jsx(SidebarImpl, { open: open, className: className, onOpenChanged: onOpenChanged, children: children }));
};
Sidebar.Body = Body;
Sidebar.Item = Item;
Sidebar.Menu = Menu;
Sidebar.Submenu = Submenu;
Sidebar.defaultProps = {
    children: null,
    className: '',
    open: false,
    onOpenChanged: undefined,
};

export { SidebarImpl, Sidebar as default };
